export const getAsiaUserFromLocalStorage = () => {
    const user = JSON.parse(localStorage.getItem('asiaUser'))
    return user || null
}

export const getAsiaUserTokenFromLocalStorage = () => {
    const token = JSON.parse(localStorage.getItem('asiaUserToken'))
    return token
}
